import { v4 as uuidv4 } from "uuid";

/**
 * Generates a unique ID using nanoid.
 * @returns A unique ID
 */
export function id(): string {
    return uuidv4();
}

/**
 * Truncates a string to the specified length and adds ellipsis if truncated.
 * @param str The string to truncate
 * @param maxLength The maximum length of the string (default: 100)
 * @returns The truncated string with ellipsis if needed
 */
export function truncate(str: string, maxLength: number = 100): string {
    if (!str) return "";

    if (str.length <= maxLength) {
        return str;
    }

    return `${str.substring(0, maxLength - 3)}...`;
}

export function getLetterAtIndex(index: number) {
    return String.fromCharCode(65 + index);
}
